import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Chart from './Chart'
import AlertCount from './AlertCount';
import { styles } from '../../styles/card-styles';
import { fetchMonitorById, fetchAlertsByMonitorId } from '../../utils/api';
import { buildDataMapContainer } from 'src/utils/handle-data';
import * as utils from './utils';

function DetailsCardContent(props) {
  const { classes, unit, rangeSetting, chartProps, panel } = props;
  const id = chartProps.detailsMonitorId;
  const alerts = chartProps.allAlerts[id];
  const [data, setData] = React.useState([]);
  const [ticks, setTicks] = React.useState([]);
  React.useEffect(() => {
    if(chartProps.type === "response") {
      fetchMonitorById(id).then(res => {
        const data = utils.buildDetailsCardData(res.result.Items, chartProps);
        setData(data.dataSet);
        setTicks(data.ticks)
      })     
    } else setData(props.data);     
  // }, 60000)
  }, [])
  
  return (
    <div className={classes.contentContainer}>
      <Chart times={data} unit={unit} chartProps={chartProps} alerts={alerts} ticks={ticks} />
      <AlertCount alerts={alerts} range={rangeSetting} panel={chartProps.panel} type={chartProps.type} />
    </div>           
  )
}

DetailsCardContent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DetailsCardContent);


// WEBPACK FOOTER //
// ./src/components/ChartCard/DetailsCardContent.js